const SESSION_KEY = 'proship_session_id'

export function getSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(SESSION_KEY, id)
  }
  return id
}

export function resetSession() {
  sessionStorage.removeItem(SESSION_KEY)
}
